import { useState } from "react";
import { Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { formatError, startCheckout } from "../../lib/api";

const AMOUNTS = ["10", "25", "50", "100"];

export function TipDialog({ open, onOpenChange, postId }) {
  const [amount, setAmount] = useState("25");
  const [note, setNote] = useState("");
  const [busy, setBusy] = useState(false);

  const send = async () => {
    setBusy(true);
    try {
      await startCheckout({ kind: "tip", tip: amount, post_id: postId || null, note: note || null });
    } catch (e) {
      toast.error(formatError(e));
      setBusy(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent data-testid="tip-dialog" className="bg-[#FFFFFF] border-[#D7263D]/30 max-w-md">
        <DialogHeader>
          <DialogTitle className="font-display text-3xl font-normal text-[#0E1B3D]">Send Katie a tip</DialogTitle>
          <DialogDescription className="text-[#4A5878]">A one-time thank-you, paid securely with Stripe.</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-4 gap-2 mt-4">
          {AMOUNTS.map((a) => (
            <button key={a} data-testid={`tip-amount-${a}`} onClick={() => setAmount(a)}
              className={`py-4 font-display text-xl border transition-colors duration-300 ${amount === a ? "border-[#D7263D] bg-[#D7263D] text-[#FFF8EE]" : "border-[#0E1B3D]/15 text-[#0E1B3D] hover:border-[#D7263D]/60"}`}>
              ${a}
            </button>
          ))}
        </div>
        <input data-testid="tip-note-input" maxLength={200} value={note} onChange={(e) => setNote(e.target.value)} placeholder="Add a note (optional)"
          className="mt-4 w-full bg-transparent border-b border-[#0E1B3D]/20 focus:border-[#D7263D] outline-none py-3 text-sm text-[#0E1B3D] placeholder:text-[#6B7894]" />
        <button data-testid="tip-submit-btn" disabled={busy} onClick={send} className="gold-btn mt-6 w-full py-4 text-sm font-semibold tracking-[0.14em] uppercase flex items-center justify-center gap-2 disabled:opacity-60">
          {busy && <Loader2 className="w-4 h-4 animate-spin" />} Tip ${amount}
        </button>
      </DialogContent>
    </Dialog>
  );
}
